import $ from 'jquery';
import 'jquery-datetimepicker';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';

export function setDateRange (from,to){
    getFromInput().val(from)
    getToInput().val(to)
}

export function getFromInput(){
    return $('#myScheduleDateFrom');
}

export function getToInput(){
    return $('#myScheduleDateTo');
}

export function initDataPicker(controller) {
    $.datetimepicker.setLocale('ru');

    $('#myScheduleDateFrom, #myScheduleDateTo').datetimepicker({
        format: 'Y-m-d',
        timepicker: false,
        dayOfWeekStart: 1,

        onSelectDate: () => {
            controller.updateFilterButtons();
        },
    });
}